import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {QRFormService} from "../../../../infrastructure/services/qr.service";
import {TranslateService} from "@mangosoft/mango-layout";

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss']
})
export class FormsComponent implements OnInit, OnDestroy{
  destroy$ = new Subject<void>();

  @Input() qrForm: boolean = false;
  @Input() qrLabel: string = "";
  @Input() qrShowUrl: boolean = false;
  @Input() formUrl: string = "";
  @Input() inputProperties: any;
  @Output() formSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();

  loadingQr: boolean = true;
  qrGeneratedUrl: string = '';
  showMode: string = 'form'
  urlCopied: boolean = false;

  language: any;

  constructor(
    private qrFormService: QRFormService,
    private translateService: TranslateService
  ) {
  }

  onFormSave(event: any){
    console.log("Webcomponent Event =>", event);
    this.formSave.emit(event);
  }

  onFormSubmit(event: any){
    console.log("Webcomponent Event =>", event);
    this.formSubmit.emit(event);
  }

  ngOnInit() {
    this.translateService
      .init("process-manager")
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.language = data
      });

    console.log("QR DATA=>",{
      qrForm: this.qrForm,
      formUrl: this.formUrl,
      formId: this.inputProperties.formId,
      versionId: this.inputProperties.versionId,
      customKey: this.inputProperties.customKey
    })

    if (this.qrForm && this.formUrl && this.inputProperties.formId && this.inputProperties.versionId && this.inputProperties.customKey){
      this.qrFormService.generateFormQR({
        formUrl: this.formUrl,
        formId: this.inputProperties.formId,
        versionId: this.inputProperties.versionId,
        customKey: this.inputProperties.customKey,
        page: this.inputProperties?.page || '1'
      }).pipe(
        takeUntil(this.destroy$)
      ).subscribe((value) => {
        console.log(value);
        this.qrGeneratedUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${value}`
      })
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  qrLoaded(){
    this.loadingQr = false
  }

  async copyUrl(){
    try {
      await navigator.clipboard.writeText(
        `${this.formUrl}/fill?formId=${this.inputProperties?.formId}&versionId=${this.inputProperties?.versionId}&page=${this.inputProperties.page || '1'}&customKey=${this.inputProperties.customKey}`
      );
      this.urlCopied = true;

      // Reiniciar el mensaje después de un tiempo
      setTimeout(() => {
        this.urlCopied = false;
      }, 5000);

    } catch (err) {
      console.error('Error al copiar la URL:', err);
    }
  }
}
